// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  features/dashboard/services/widgetsService.ts
//  Dados dos widgets (espelham DashboardWidgetsDtos.cs).
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';

const BASE = '/api/dashboard';

export interface TitulosRecorte { qtd: number; valor: number }
export interface ContasVencer {
  receberHoje: TitulosRecorte;
  pagarHoje: TitulosRecorte;
  receberSeteDias: TitulosRecorte;
  pagarSeteDias: TitulosRecorte;
}
export interface Inadimplencia {
  qtdTitulosVencidos: number;
  valorVencido: number;
  carteiraAberta: number;
  percentualCarteira: number;
}
export interface FluxoProjetado {
  dias: number;
  entradasPrevistas: number;
  saidasPrevistas: number;
  saldoProjetado: number;
}
export interface ContratosResumo {
  ativos: number;
  vencendoTrintaDias: number;
  valorTotalAtivos: number;
}
export interface AgendaItem {
  id: number;
  titulo: string;
  dtInicio: string;
  tipo: string;
  status: string;
  cliente: string | null;
}
export interface OsResumo { abertas: number; emitidasMes: number; concluidasMes: number }
export interface VendasDia { qtdVendas: number; totalLiquido: number; ticketMedio: number }
export interface FiscalEmissao {
  nfeQtd: number;
  nfeValor: number;
  nfceQtd: number;
  nfceValor: number;
  canceladas: number;
}
export interface CrmKpis {
  valorPipelineAberto: number;
  oportunidadesAbertas: number;
  taxaConversao: number;
  valorGanhoMes: number;
}

export const widgetsService = {
  contasVencer: async (): Promise<ContasVencer> =>
    (await apiClient.get(`${BASE}/financeiro/contas-vencer`)).data,
  inadimplencia: async (): Promise<Inadimplencia> =>
    (await apiClient.get(`${BASE}/financeiro/inadimplencia`)).data,
  fluxoProjetado: async (dias = 30): Promise<FluxoProjetado> =>
    (await apiClient.get(`${BASE}/financeiro/fluxo-projetado`, { params: { dias } })).data,
  contratosResumo: async (): Promise<ContratosResumo> =>
    (await apiClient.get(`${BASE}/contratos/resumo`)).data,
  agendaHoje: async (): Promise<AgendaItem[]> =>
    (await apiClient.get(`${BASE}/agenda/hoje`)).data,
  osResumo: async (): Promise<OsResumo> =>
    (await apiClient.get(`${BASE}/os/resumo`)).data,
  vendasResumoDia: async (): Promise<VendasDia> =>
    (await apiClient.get(`${BASE}/vendas/resumo-dia`)).data,
  fiscalResumoEmissao: async (): Promise<FiscalEmissao> =>
    (await apiClient.get(`${BASE}/fiscal/resumo-emissao`)).data,
  crmKpis: async (): Promise<CrmKpis> => {
    // Reusa o dashboard CRM completo e recorta só os KPIs do mini-widget.
    const { data } = await apiClient.get('/api/crm/dashboard', { params: { mesesEvolucao: 1 } });
    return {
      valorPipelineAberto: data?.kpis?.valorPipelineAberto ?? 0,
      oportunidadesAbertas: data?.kpis?.oportunidadesAbertas ?? 0,
      taxaConversao: data?.kpis?.taxaConversao ?? 0,
      valorGanhoMes: data?.kpis?.valorGanhoMes ?? 0,
    };
  },
};
